import api from '@/modules/milenium/api';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import { modifiedProperties } from '@/utils';
import toast from '@/modules/toast/services';

const INIT_EDITOR = async ({ dispatch, commit }, contentId) => {
  try {
    const response = await api.getContentPagePositionEditor(contentId);
    commit('INIT_EDITOR', { contentId, ...response });
  } catch (error) {
    commit('RESET_EDITOR');
    throw error;
  }
};

const UPDATE_FIELDS = async ({ commit }, fields) => {
  commit('UPDATE_DRAFT', fields);
};

const UPDATE_FORM_ERRORS = async ({ commit, state }, errors) => {
  if (isEqual(state.errors, errors)) return;
  commit('SET_FORM_ERRORS', errors || []);
};

const UPDATE_FORM_FLAGS = async ({ commit, state }, flags) => {
  if (isEqual(state.flags, flags)) return;
  commit('SET_FORM_FLAGS', flags || {});
};

const SAVE = async ({ commit, state, rootGetters }) => {
  const {
    contentId, master, draft,
  } = state;
  // Find modified fields
  const modifiedFields = modifiedProperties(draft, master);
  const payload = pick(draft, modifiedFields);
  // Apply the context to the payload
  payload.context = rootGetters.context;
  // Now we call the backend api to persist the diff
  const response = await api.patchContentPagePosition(contentId, payload);
  if (!response) {
    return Promise.reject();
  }
  const {
    fields,
    fieldsLines,
    masterChannelValues,
    previewUrl,
  } = response;
  commit('SET_MASTER', fields);
  commit('SET_PREVIEW_URL', previewUrl);
  commit('SET_FIELDS_LINES', fieldsLines);
  commit('SET_MASTER_CHANNEL_VALUES', masterChannelValues);
  return Promise.resolve();
};

const FINISH = async ({ commit, state }, contentId) => {
  await api.finishContentPagePosition(contentId);
  commit('SET_FINISHED', true);
  toast.notify('message.milenium.finishedSuccess');
};

const UNLINK = async ({ commit, state }, contentId) => {
  await api.unlinkContentPagePosition(contentId);
  toast.notify('message.milenium.unlinkSuccess');
  location.reload();
};

export default {
  INIT_EDITOR,
  UPDATE_FIELDS,
  UPDATE_FORM_ERRORS,
  UPDATE_FORM_FLAGS,
  SAVE,
  FINISH,
  UNLINK,
};
